import styled from 'styled-components';
import {
  EllipsisWithLineClamp,
  media,
  DeprecatedGrid as Grid,
} from '@simplywallst/ui-core';

export const Wrapper = styled(Grid)`
  min-height: 122px;
  padding: ${({ theme }) => theme.x1spacePx}px;
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  transition: background 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  background-color: ${({ theme }) => theme.color.spaceGray};
  ${media.lgUp`
    min-height: 124px;
    &:hover {
      background-color: ${({ theme }) => theme.color.spaceGray};
    }
  `}
`;

export const Body = styled('div')`
  color: ${({ theme }) => theme.color.white};
  ${({ theme }) => theme.typography.xSmall}
  padding: ${({ theme }) => theme.x1spacePx}px;
  cursor: pointer;
  word-break: break-word;
  ${EllipsisWithLineClamp(5)}
  ${media.mdUp`
    ${EllipsisWithLineClamp(4)}
  `}
  ${media.lgUp`
    ${EllipsisWithLineClamp(3)}
  `}
`;

export const Footer = styled(Grid)`
  margin: 0 ${({ theme }) => theme.x1spacePx}px;
`;

export const StyledAccessibleButton = styled('button')`
  display: block;
  margin: 0px;
  padding: 0px;
  appearance: none;
  background: transparent;
  border: 0px;
  line-height: 1;
  outline: 0px;
`;
